import { render, staticRenderFns } from "./findOpportunity.vue?vue&type=template&id=75b68a23&scoped=true"
import script from "./findOpportunity.vue?vue&type=script&lang=js"
export * from "./findOpportunity.vue?vue&type=script&lang=js"
import style0 from "./findOpportunity.vue?vue&type=style&index=0&id=75b68a23&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b68a23",
  null
  
)

export default component.exports